#import "../fragments/user-email-fragment.graphql"

mutation UpdateSmtpSettings($smtpSettings: SmtpSettingsUpdateInputFieldInput!) {
    smtpSettingsUpdate(input: {smtpSettings: $smtpSettings}) {
        userEmail {
            ...UserEmail
        }
    }
}
